import React from 'react'

import { Button, makeStyles, Theme } from '@material-ui/core'

import {
    RecordsTrailExportFormat,
    useRecordsTrailExport,
} from '../../hooks/useRecords'

const useStyles = makeStyles((theme: Theme) => ({
    row: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        padding: theme.spacing(1.5, 2, 0),
        marginLeft: 'auto',
    },
}))

interface TrailExportProps {
    userId?: number | null
    leadId?: number | null
    unitId?: number | null
    kinds?: string | null
}

export const TrailExport = ({
    userId = null,
    leadId = null,
    unitId = null,
    kinds = null,
}: TrailExportProps) => {
    const classes = useStyles()
    const { download, busyFormat, canExport } = useRecordsTrailExport({
        userId,
        leadId,
        unitId,
        kinds,
    })

    const button = (format: RecordsTrailExportFormat, label: string) => (
        <Button
            size="small"
            color="primary"
            variant="outlined"
            disabled={!canExport || busyFormat != null}
            onClick={() => download(format)}
        >
            {busyFormat === format ? 'Exporting…' : label}
        </Button>
    )

    return (
        <div className={classes.row}>
            {button('xlsx', 'Export Excel')}
            {button('pdf', 'Export PDF')}
        </div>
    )
}
